import React from 'react';
import PropTypes from 'prop-types';
import clsx from "clsx";
import style from "./SingleViewHeader.module.scss";
import parse from 'html-react-parser';

const WidgetListItemComponent = props => {
    const {icon} = props;
    const value = icon.value || '';

    return (
        <div className={clsx([style.widgetListItem])}>
            <div className={style.widgetListItemTitle}>
                {icon.title}
            </div>
            <div className={style.widgetListItemValue}>
                {typeof value === 'string' ? parse(value) : ''}
            </div>
            {icon.icon}
        </div>
    );
};

WidgetListItemComponent.propTypes = {
    icon: PropTypes.shape({
        title: PropTypes.string.isRequired,
        value: PropTypes.string,
        icon: PropTypes.node
    }).isRequired
};

export default WidgetListItemComponent;